"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCardPaymentCapabilityBlockedMockData = exports.buildOwnershipVerificationHelperMockData = exports.buildStripeVerificationCompletedMockData = exports.buildStripeRiskReviewMockData = exports.buildStripeInformationRequiredMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const MOCK_BANK_PAGE_URL = "https://www.zeffy.com/en-US/o/bank";
const MOCK_HELP_URL = "https://support.zeffy.com/";
const MOCK_VERIFICATION_CAUSES = [
    {
        shortLabel: "Your EIN doesn't match your IRS records",
        paragraph: "Compare your organization's legal name and EIN with your IRS records, including punctuation and legal suffixes. If everything already matches, submit an IRS CP 575, 147C or SS-4 letter if Stripe requests additional proof.",
        helpUrl: MOCK_HELP_URL,
    },
    {
        shortLabel: "Your document has expired",
        paragraph: "Upload a valid document. A proof of address must be dated within the last 6 months.",
        helpUrl: MOCK_HELP_URL,
    },
];
const MOCK_MISSING_FIELDS = ["Your representative's date of birth", "Your organization's EIN"];
const getMockVerificationContent = (variant) => {
    switch (variant) {
        case "oneCause":
            return { causes: MOCK_VERIFICATION_CAUSES.slice(0, 1), missingFields: [], showGuideLink: false };
        case "severalCauses":
            return { causes: MOCK_VERIFICATION_CAUSES, missingFields: MOCK_MISSING_FIELDS, showGuideLink: false };
        case "missingInformation":
            return { causes: [], missingFields: MOCK_MISSING_FIELDS, showGuideLink: true };
        case "fallback":
            return { causes: [], missingFields: [], showGuideLink: true };
    }
};
const buildStripeInformationRequiredMockData = ({ locale = "en", subject = "Action required on your Stripe account", firstName = "John", orgName = "Bright Futures Foundation", variant = "oneCause", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    isOneCause: variant === "oneCause",
    isSeveralCauses: variant === "severalCauses",
    isMissingInformation: variant === "missingInformation",
    isFallback: variant === "fallback",
    ...getMockVerificationContent(variant),
    guideUrl: MOCK_HELP_URL,
    bankPageUrl: MOCK_BANK_PAGE_URL,
});
exports.buildStripeInformationRequiredMockData = buildStripeInformationRequiredMockData;
const buildStripeRiskReviewMockData = ({ locale = "en", subject = "Stripe is reviewing your account", firstName = "John", orgName = "Bright Futures Foundation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    bankPageUrl: MOCK_BANK_PAGE_URL,
});
exports.buildStripeRiskReviewMockData = buildStripeRiskReviewMockData;
const buildStripeVerificationCompletedMockData = ({ locale = "en", subject = "Your account verification is complete", firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildStripeVerificationCompletedMockData = buildStripeVerificationCompletedMockData;
const buildOwnershipVerificationHelperMockData = ({ locale = "en", subject = "Verify your business ownership", firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildOwnershipVerificationHelperMockData = buildOwnershipVerificationHelperMockData;
const buildCardPaymentCapabilityBlockedMockData = ({ locale = "en", subject = "Card payments are paused", firstName = "John", formName = "Spring Gala 2026", settingsUrl = "https://www.zeffy.com/en-US/o/settings/organization", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    formName,
    settingsUrl,
});
exports.buildCardPaymentCapabilityBlockedMockData = buildCardPaymentCapabilityBlockedMockData;
